module.exports = __webpack_public_path__ + "img/la.90d6665d.svg";